import {type TimeZone} from '@hconnect/common/types'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../consts'
import {getLocationStatusQuickSelectionItems} from '../utils'

import {DateTimeRangePicker} from './DateTimeRangePicker'

type LocationStatusFiltersProps = {
  timeRangeParam: string
  onTimeRangeParamChange: (timeRange: string) => void
  timezone: TimeZone
  disabled?: boolean
  inverted?: boolean
}

export const LocationStatusFilters: React.FC<LocationStatusFiltersProps> = ({
  timeRangeParam,
  onTimeRangeParamChange,
  disabled,
  timezone,
  inverted = false
}) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const selectionItems = getLocationStatusQuickSelectionItems(t, timezone)

  return (
    <DateTimeRangePicker
      timeRangeParam={timeRangeParam}
      onTimeRangeParamChange={onTimeRangeParamChange}
      timezone={timezone}
      quickSelectionItems={selectionItems}
      disabled={disabled}
      inverted={inverted}
    />
  )
}
